import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DynamicPage from "./DynamicPage";
import { fetchTripByPath } from "../services/apiService";

const DynamicPageWrapper = ({ categories }) => {
  const { tripPath } = useParams();
  const [trip, setTrip] = useState(null);
  const [loadError, setLoadError] = useState(null);

  // The category list only carries trip cards; the full trip is loaded here by its path.
  useEffect(() => {
    let cancelled = false;
    setTrip(null);
    setLoadError(null);
    fetchTripByPath(tripPath)
      .then((data) => {
        if (!cancelled) setTrip(data);
      })
      .catch((error) => {
        if (!cancelled) setLoadError(error?.response?.status === 404 ? "notFound" : "failed");
      });
    return () => {
      cancelled = true;
    };
  }, [tripPath]);

  if (loadError === "notFound") {
    return <h2 className="text-center mt-5">404 – Trip Not Found</h2>;
  }

  if (loadError) {
    return <h2 className="text-center mt-5">Could not load this trip. Please refresh the page.</h2>;
  }

  if (!trip) {
    return <h2 className="text-center mt-5">Loading...</h2>; // optional loading message
  }

  return <DynamicPage key={trip.id || trip.path} trip={trip} categories={categories} />;
};

export default DynamicPageWrapper;
